import { API } from 'app/utils/client';
import { IMembership } from 'app/models';
import { CRUDService } from './api';

export class MembershipService extends CRUDService<IMembership> { }

const instance = new MembershipService(API, 'v1/memberships');
export default instance;
